module.exports = __webpack_public_path__ + "img/Circulo-Logo-Impresion3D-Gris.dd5d5b1f.png";